import React from 'react';

// Badge di confidenza per i numeri del dataset open (W2).
// Stessa semantica e stessa palette dei badge della chat (ChatWidget.css,
// .chat-badge-*): tenere i due file in sync se cambia una delle due palette.
// Solo classi Tailwind standard (CDN v2, niente valori arbitrari).
const BADGE_STYLES = {
  high: 'bg-green-100 text-green-800',
  medium: 'bg-yellow-100 text-yellow-800',
  low: 'bg-gray-200 text-gray-600'
};

const ConfidenceBadge = ({ level, sources }) => {
  if (!level || !BADGE_STYLES[level]) {
    return null;
  }
  const sourcesPart = sources
    ? ` — ${sources} source${Number(sources) > 1 ? 's' : ''}`
    : '';
  return (
    <span
      className={`inline-block px-1.5 py-0.5 rounded-full text-xs font-semibold uppercase align-middle ${BADGE_STYLES[level]}`}
      title={`Confidence: ${level}${sourcesPart} (sustAId open dataset)`}
    >
      {level}
    </span>
  );
};

export default ConfidenceBadge;
